import { FilterOption } from '../../models/option.interface';
import { API_VERSIONS } from '../../consts/api-versions.const';
import { UsersGroup } from '../../enums/users-group.enum';

export const claimUsersSuccessCallback = (res: any[]) =>
  res?.map((i) => ({
    ...i,
    company_name: i?.third_party_info?.name
      ? i?.third_party_info?.name
      : i?.first_name + ' ' + i?.last_name,
  }));

export const CLAIM_FILTER_MAP = {
  status: {
    name: 'Filter by Status',
    key: 'filter_by_status',
    isCheckbox: true,
    options: [],
  },
  adjustor: {
    name: 'Filter by Claim Adjuster',
    key: 'filter_by_adjustor',
    isAutocomplete: true,
    autocompleteUrl: `/${API_VERSIONS.USERS}/users?filter_by_group=10`,
    searchCategory: 'search',
    optionLabel: ['first_name', 'last_name'],
    placeholder: 'Search Claim adjustor',
    optionValue: 'id',
    options: [],
  },
  repairFacility: {
    name: 'Filter by Repair Facility',
    key: 'filter_by_repair_facility',
    isAutocomplete: true,
    autocompleteUrl: `/${API_VERSIONS.THIRD_PARTIES}/third-parties?filter_by_type=6`,
    searchCategory: 'global_search',
    placeholder: 'Search Repair Facility',
    optionLabel: 'company_name',
    optionValue: 'id',
    options: [],
  },
  serviceAdvisor: {
    name: 'Filter by Service Advisor',
    key: 'filter_by_service_advisor',
    isAutocomplete: true,
    autocompleteUrl: `/${API_VERSIONS.THIRD_PARTIES}/third-parties?filter_by_type=7`,
    searchCategory: 'global_search',
    optionLabel: 'company_name',
    placeholder: 'Search Service Advisor',
    optionValue: 'id',
    options: [],
  },
  createdBy: {
    name: 'Filter by Created By',
    key: 'filter_by_created_by',
    isAutocomplete: true,
    autocompleteUrl: `/${API_VERSIONS.USERS}/users?filter_by_group=10`,
    searchCategory: 'search',
    optionLabel: ['first_name', 'last_name'],
    placeholder: 'Search User',
    optionValue: 'id',
    options: [],
  },
  creationDateRange: {
    name: 'Filter by Creation Date Range',
    key: 'filter_by_creation_date',
    isDateRange: true,
    placeholder: 'Select Range',
    options: [],
  },
  lastStatusUpdateDate: {
    name: 'Filter by Last Status Change Date',
    key: 'filter_by_last_status_change_date',
    isDate: true,
    placeholder: 'Select Date',
    options: [],
  },
  paidAmount: {
    name: 'Paid Amount',
    key: 'filter_by_amount',
    isNumberRange: true,
    minKey: 'filter_by_amount_min',
    maxKey: 'filter_by_amount_max',
    placeholder: 'Min – Max',
    options: [],
  },
  authorizedAmount: {
    name: 'Authorized Amount',
    key: 'filter_by_authorized_amount',
    isNumberRange: true,
    minKey: 'filter_by_authorized_amount_min',
    maxKey: 'filter_by_authorized_amount_max',
    placeholder: 'Min – Max',
    options: [],
  },
  lastUpdatedBy: {
    name: 'Filter by Last Updated By',
    key: 'filter_by_updated_by',
    isAutocomplete: true,
    autocompleteUrl: `/${API_VERSIONS.USERS}/users?filter_by_group=10`,
    searchCategory: 'search',
    optionLabel: ['first_name', 'last_name'],
    optionValue: 'id',
    placeholder: 'Search User',
    options: [],
  },
  dealer: {
    name: 'Filter by dealer',
    key: 'filter_by_dealers',
    isAutocomplete: true,
    autocompleteUrl: `/${API_VERSIONS.USERS}/users/paging?filter_by_group=5`,
    optionLabel: ['company_name', 'third_party_info.internal_code'],
    optionLabelSeparator: ' - ',
    optionValue: 'id',
    searchCategory: 'search',
    placeholder: 'Search for dealer',
    options: [],
    successCallback: claimUsersSuccessCallback,
  },
  dealerGroup: {
    name: 'Filter by dealer group',
    key: 'filter_by_dealer_groups',
    isAutocomplete: true,
    autocompleteUrl: `/${API_VERSIONS.USERS}/users/paging?filter_by_group=${UsersGroup.DealerGroups}`,
    optionLabel: 'company_name',
    optionValue: 'id',
    searchCategory: 'search',
    placeholder: 'Search for dealer group',
    options: [],
    successCallback: claimUsersSuccessCallback,
  },
  lienholder: {
    name: 'Filter by lienholder',
    key: 'filter_by_lienholder',
    isAutocomplete: true,
    autocompleteUrl: `/${API_VERSIONS.THIRD_PARTIES}/third-parties/paging?filter_by_type=${UsersGroup.Lienholders}`,
    optionLabel: 'third_party_name',
    optionValue: 'id',
    searchCategory: 'search',
    placeholder: 'Search for lienholder',
    options: [],
    successCallback: claimUsersSuccessCallback,
  },
  agent: {
    name: 'Filter by agent',
    key: 'filter_by_agents',
    isAutocomplete: true,
    autocompleteUrl: `/${API_VERSIONS.USERS}/users/paging?filter_by_group=2`,
    optionLabel: 'company_name',
    optionValue: 'id',
    searchCategory: 'search',
    placeholder: 'Search for agent',
    options: [],
    successCallback: claimUsersSuccessCallback,
  },
  broker: {
    name: 'Filter by broker',
    key: 'filter_by_brokers',
    isAutocomplete: true,
    autocompleteUrl: `/${API_VERSIONS.USERS}/users/paging?filter_by_group=3`,
    optionLabel: 'company_name',
    optionValue: 'id',
    searchCategory: 'search',
    placeholder: 'Search for broker',
    options: [],
    successCallback: claimUsersSuccessCallback,
  },
  prefix: {
    name: 'Filter by Prefix',
    key: 'filter_by_claims_prefix',
    placeholder: 'Select prefix',
    options: [],
  },
  isFortegraClaim: {
    name: 'Fortegra Claims',
    key: 'filter_by_is_fortegra_claim',
    placeholder: 'Select Fortegra Option',
    options: [
      { name: 'All', id: null },
      { name: 'Fortegra Only', id: '1' },
      { name: 'Non-Fortegra Only', id: '0' },
    ],
  },
  isLegalClaim: {
    name: 'Legal Claims',
    key: 'filter_by_is_legal_claim',
    placeholder: 'Select Legal Claim Option',
    options: [
      { name: 'All', id: null },
      { name: 'Legal Claims Only', id: '1' },
      { name: 'Non-Legal Claims Only', id: '0' },
    ],
  },
  isException: {
    name: 'Exception Claims',
    key: 'filter_by_exception',
    placeholder: 'Select Exception Option',
    options: [
      { name: 'All', id: null },
      { name: 'Exception Only', id: 'true' },
      { name: 'Non-Exception Only', id: 'false' },
    ],
  },
  publicNoContract: {
    name: 'Public Claims With No Contract',
    key: 'filter_by_public_no_contract',
    placeholder: 'Select public no-contract option',
    options: [
      { name: 'All claims', id: null },
      { name: 'Only public claims with no contract', id: '1' },
      { name: 'Exclude public claims with no contract', id: '0' },
    ],
  },
  productCategory: {
    name: 'Filter by Product Category',
    key: 'filter_by_product_categories',
    placeholder: 'Select category',
    options: [
      { name: 'No category', id: '--' },
      { name: 'Normal', id: 'Normal' },
      { name: 'GAP', id: 'Gap' },
      { name: 'Ancillary', id: 'Ancillary' },
      { name: 'Mechanical Breakdown', id: 'Mechanical Breakdown' },
    ],
  },
  creationMethod: {
    name: 'Filter by Creation Method',
    key: 'filter_by_creation_method',
    isCheckbox: true,
    options: [
      { name: 'Internal', id: 'internal' },
      { name: 'Public', id: 'public' },
      { name: 'Importer', id: 'importer' },
      { name: 'External', id: 'external' },
    ],
  },
  creationSource: {
    name: 'Filter by Creation Source',
    key: 'filter_by_creation_source',
    isText: true,
    placeholder: 'Enter creation source',
    options: [],
  },
  isGap: {
    name: 'GAP / Total Loss',
    key: 'filter_by_is_gap',
    placeholder: 'Select GAP option',
    options: [
      { name: 'All', id: null },
      { name: 'Yes', id: '1' },
      { name: 'No', id: '0' },
    ],
  },
  consumerType: {
    name: 'Filter by Consumer Type',
    key: 'filter_by_consumer_type',
    isCheckbox: true,
    placeholder: 'Select consumer type',
    options: [
      { name: 'Repair Facility', id: 'repair_facility' },
      { name: 'Dealership', id: 'dealership' },
      { name: 'Lienholder', id: 'lienholder' },
      { name: 'Customer', id: 'customer' },
    ],
  },
  customerState: {
    name: 'Customer State',
    key: 'filter_by_customer_state',
    isMultiSelect: true,
    placeholder: 'Select customer states',
    options: [],
  },
};

export const CLAIM_FILTER_OPTIONS: FilterOption[] = [
  CLAIM_FILTER_MAP.status,
  CLAIM_FILTER_MAP.adjustor,
  CLAIM_FILTER_MAP.repairFacility,
  CLAIM_FILTER_MAP.serviceAdvisor,
  CLAIM_FILTER_MAP.createdBy,
  CLAIM_FILTER_MAP.creationDateRange,
  CLAIM_FILTER_MAP.lastStatusUpdateDate,
  CLAIM_FILTER_MAP.paidAmount,
  CLAIM_FILTER_MAP.authorizedAmount,
  CLAIM_FILTER_MAP.lastUpdatedBy,
  CLAIM_FILTER_MAP.dealer,
  CLAIM_FILTER_MAP.dealerGroup,
  CLAIM_FILTER_MAP.agent,
  CLAIM_FILTER_MAP.broker,
  CLAIM_FILTER_MAP.lienholder,
  CLAIM_FILTER_MAP.prefix,
  CLAIM_FILTER_MAP.isFortegraClaim,
  CLAIM_FILTER_MAP.isLegalClaim,
  CLAIM_FILTER_MAP.isException,
  CLAIM_FILTER_MAP.publicNoContract,
  CLAIM_FILTER_MAP.productCategory,
  CLAIM_FILTER_MAP.creationMethod,
  CLAIM_FILTER_MAP.creationSource,
  CLAIM_FILTER_MAP.isGap,
  CLAIM_FILTER_MAP.consumerType,
  CLAIM_FILTER_MAP.customerState,
];

export const CLAIM_FILTER_OPTIONS_FOR_BROKER: FilterOption[] = [
  CLAIM_FILTER_MAP.isGap,
  CLAIM_FILTER_MAP.consumerType,
  CLAIM_FILTER_MAP.status,
  CLAIM_FILTER_MAP.adjustor,
  CLAIM_FILTER_MAP.repairFacility,
  CLAIM_FILTER_MAP.serviceAdvisor,
  CLAIM_FILTER_MAP.createdBy,
  CLAIM_FILTER_MAP.creationDateRange,
  CLAIM_FILTER_MAP.lastStatusUpdateDate,
  CLAIM_FILTER_MAP.paidAmount,
  CLAIM_FILTER_MAP.authorizedAmount,
  CLAIM_FILTER_MAP.lastUpdatedBy,
  CLAIM_FILTER_MAP.dealer,
  CLAIM_FILTER_MAP.dealerGroup,
  CLAIM_FILTER_MAP.agent,
  CLAIM_FILTER_MAP.prefix,
  CLAIM_FILTER_MAP.isLegalClaim,
  CLAIM_FILTER_MAP.isException,
  CLAIM_FILTER_MAP.productCategory,
  CLAIM_FILTER_MAP.creationMethod,
  CLAIM_FILTER_MAP.creationSource,
  CLAIM_FILTER_MAP.customerState,
];

export const CLAIM_FILTER_OPTIONS_FOR_DEALER: FilterOption[] = [
  CLAIM_FILTER_MAP.isGap,
  CLAIM_FILTER_MAP.consumerType,
  CLAIM_FILTER_MAP.status,
  CLAIM_FILTER_MAP.adjustor,
  CLAIM_FILTER_MAP.repairFacility,
  CLAIM_FILTER_MAP.serviceAdvisor,
  CLAIM_FILTER_MAP.createdBy,
  CLAIM_FILTER_MAP.creationDateRange,
  CLAIM_FILTER_MAP.lastStatusUpdateDate,
  CLAIM_FILTER_MAP.paidAmount,
  CLAIM_FILTER_MAP.authorizedAmount,
  CLAIM_FILTER_MAP.lastUpdatedBy,
  CLAIM_FILTER_MAP.prefix,
  CLAIM_FILTER_MAP.productCategory,
  CLAIM_FILTER_MAP.dealerGroup,
  CLAIM_FILTER_MAP.isLegalClaim,
  CLAIM_FILTER_MAP.isException,
  CLAIM_FILTER_MAP.creationMethod,
  CLAIM_FILTER_MAP.creationSource,
  CLAIM_FILTER_MAP.customerState,
];

export const CLAIM_FILTER_OPTIONS_FOR_MANAGEMENT: FilterOption[] = [
  CLAIM_FILTER_MAP.isGap,
  CLAIM_FILTER_MAP.consumerType,
  CLAIM_FILTER_MAP.status,
  CLAIM_FILTER_MAP.adjustor,
  CLAIM_FILTER_MAP.repairFacility,
  CLAIM_FILTER_MAP.serviceAdvisor,
  CLAIM_FILTER_MAP.createdBy,
  CLAIM_FILTER_MAP.creationDateRange,
  CLAIM_FILTER_MAP.lastStatusUpdateDate,
  CLAIM_FILTER_MAP.paidAmount,
  CLAIM_FILTER_MAP.authorizedAmount,
  CLAIM_FILTER_MAP.lastUpdatedBy,
  CLAIM_FILTER_MAP.dealer,
  CLAIM_FILTER_MAP.dealerGroup,
  CLAIM_FILTER_MAP.agent,
  CLAIM_FILTER_MAP.broker,
  CLAIM_FILTER_MAP.lienholder,
  CLAIM_FILTER_MAP.isFortegraClaim,
  CLAIM_FILTER_MAP.isLegalClaim,
  CLAIM_FILTER_MAP.isException,
  CLAIM_FILTER_MAP.publicNoContract,
  CLAIM_FILTER_MAP.productCategory,
  CLAIM_FILTER_MAP.creationMethod,
  CLAIM_FILTER_MAP.creationSource,
  CLAIM_FILTER_MAP.customerState,
];
